export const DEFAULT_COUNTRY_CODE = 840
export const DEFAULT_COUNTRY_ISO_CODE = "US"
export const DEFAULT_COUNTRY_NAME =  "UNITED STATES OF AMERICA"

export const PRODUCT_SELECTION_STAGE = 1;
export const SUBSCRIPTION_DETAILS_STAGE = 2;
export const REVIEW_STAGE = 3;
export const CONFIRM_PLACE_ORDER = 4;

export const PUBLIC_VSS_USER_ID = "PUBLIC_VSS_USER";

export const LibraryPostFileClickAction = {
    Download: 1,
    Link: 2,
    Open: 3
}

export const TERMS_OF_USE_LATEST_VERSION = 'v3';
